import { showNotification } from '@mantine/notifications'
import { ApplicantStatusValues } from 'modules/admissions/consts'
import { useApplicantMutations } from 'modules/admissions/mutations.hooks'
import { GET_APPLICATION_FROM_TOKEN } from 'modules/admissions/queries'
import { ApplicantNode } from 'modules/admissions/types.graphql'
import {
  RegisterInformationFormValues,
  RegisterInformationSubmitData,
} from './useRegisterInformationLogic'

interface UseRegisterInformationAPIInput {
  applicant: ApplicantNode
}

export function useRegisterInformationAPI({
  applicant,
}: UseRegisterInformationAPIInput) {
  const { patchApplicant } = useApplicantMutations()

  async function handleSubmit(data: RegisterInformationSubmitData) {
    const { id } = applicant
    const input = {
      ...data,
      status: ApplicantStatusValues.HAS_REGISTERED_PROFILE,
      lastActivity: new Date(),
    }

    // TODO replace with custom mutation using applicant token
    return patchApplicant({
      variables: {
        id: id,
        input: input,
      },
      refetchQueries: [GET_APPLICATION_FROM_TOKEN],
      onError({ message }) {
        showNotification({
          title: 'Noe gikk galt',
          message,
        })
      },
    })
  }

  const defaultValues: RegisterInformationFormValues = {
    firstName: applicant?.firstName ?? '',
    lastName: applicant?.lastName ?? '',
    address: applicant?.address ?? '',
    hometown: applicant?.hometown ?? '',
    study: applicant?.study ?? '',
    gdprConsent: applicant?.gdprConsent ?? false,
    dateOfBirth: null,
    phone: applicant?.phone ?? '',
    phoneRepeated: applicant?.phone ?? '',
    wantsDigitalInterview: applicant?.wantsDigitalInterview ?? false,
  }
  return {
    defaultValues,
    onSubmit: handleSubmit,
  }
}
